export const translateTextualContent = () => {
    const recurseDOM = scope => {
		let i = 0, nodes, node;
		if(scope.childNodes)
		{
			nodes = scope.childNodes;
			for(i; i<nodes.length; i++)
			{
                node = nodes[i];
                
				if(node.nodeType === 3)
				{
					const data = node.data.trim()
                    if (data) {
                        node.data = node.data.replace(data, t(data))
                    }    
                }
                
				if(node.childNodes)
				{
					// loop through child nodes if child nodes are found
					recurseDOM(node);
				}
				node = null;
			}
			nodes = null;
		}   
    }
    
    recurseDOM(document.body);
}

export const t = (lookup) => {
    if (localStorage.getItem('lang') == 'pt') {
        switch (lookup) {
            // Welcome and redesign popups, camera message
            case 'A simpler JustSketchMe': return 'Um JustSketchMe mais simples'
            case 'I\'ve reorganised everything around a classic menu bar, so each tool has a clear name instead of an icon you have to guess at. Everything is still here, just easier to find.': return 'Reorganizei tudo em torno de uma barra de menus clássica, para que cada ferramenta tenha um nome claro em vez de um ícone que você precisa adivinhar. Tudo continua aqui, só que mais fácil de encontrar.'
            case 'Your basic tools are in the top right (or bottom center on mobile). The rest of the menus should be self-explanatory.': return 'Suas ferramentas básicas ficam no canto superior direito (ou embaixo, no centro, no celular). O resto dos menus deve ser autoexplicativo.'
            case 'This update was a long time in the making, picked up and put down many times over the years. I hope you enjoy the updates! Please': return 'Esta atualização levou muito tempo para ficar pronta, retomada e deixada de lado muitas vezes ao longo dos anos. Espero que você goste das novidades! Por favor,'
            case 'contact me': return 'entre em contato'
            case 'if you run into any issues.': return 'se tiver algum problema.'
            case 'Got it': return 'Entendi'
            case 'Welcome to JustSketchMe': return 'Bem-vindo ao JustSketchMe'
            case 'Pose': return 'Posar'
            case 'Rotate:': return 'Girar:'
            case 'drag a coloured dot to rotate that joint.': return 'arraste um ponto colorido para girar essa articulação.'
            case 'Move:': return 'Mover:'
            case 'drag to move a character, prop or limb.': return 'arraste para mover um personagem, objeto ou membro.'
            case 'Scale:': return 'Escala:'
            case 'drag to make an object bigger or smaller.': return 'arraste para deixar um objeto maior ou menor.'
            case 'Hide tools:': return 'Esconder ferramentas:'
            case 'hides the dots for a clean view of your pose.': return 'esconde os pontos para uma visão limpa da sua pose.'
            case 'Move around': return 'Navegar'
            case 'Orbit:': return 'Orbitar:'
            case 'drag the background, or drag with one finger.': return 'arraste o fundo, ou arraste com um dedo.'
            case 'Pan:': return 'Deslocar:'
            case 'right-drag, or drag with two fingers.': return 'arraste com o botão direito, ou arraste com dois dedos.'
            case 'Zoom:': return 'Zoom:'
            case 'scroll, or pinch.': return 'role a roda do mouse, ou faça pinça.'
            case 'Select and modify characters': return 'Selecionar e modificar personagens'
            case 'Each character has a tab in the top left. Click it to select that character.': return 'Cada personagem tem uma aba no canto superior esquerdo. Clique nela para selecionar esse personagem.'
            case 'Click the': return 'Clique no'
            case 'on a tab (or right-click it) to change colour, duplicate, flip, hide, lock or delete.': return 'de uma aba (ou clique com o botão direito nela) para mudar a cor, duplicar, espelhar, ocultar, bloquear ou excluir.'
            case 'Add things': return 'Adicionar coisas'
            case 'Use the menu bar to add characters and props, apply poses and hand poses, and export a screenshot.': return 'Use a barra de menus para adicionar personagens e objetos, aplicar poses e poses de mão, e exportar uma captura de tela.'
            case 'Start posing': return 'Começar a posar'
            case 'Getting started': return 'Primeiros passos'
            case 'Back to the starting view. Hold the camera button to save your own.': return 'De volta à vista inicial. Segure o botão da câmera para salvar a sua.'

            // Menu bar, object menus and upgrade panel
            case 'Unlock the prop library': return 'Desbloqueie a biblioteca de objetos'
            case 'Unlock the pose library': return 'Desbloqueie a biblioteca de poses'
            case 'Export 3D model': return 'Exportar modelo 3D'
            case 'Upload prop': return 'Upload de modelo'
            case 'Show 3D gizmo': return 'Mostrar gizmo 3D'
            case 'Version': return 'Versão'
            case 'View': return 'Visualizar'
            case 'Edit': return 'Editar'
            case 'Props': return 'Objetos'
            case 'Hands': return 'Mãos'
            case 'Export': return 'Exportar'
            case 'Help': return 'Ajuda'
            case 'Rotate': return 'Girar'
            case 'Move': return 'Mover'
            case 'Mirror posing': return 'Pose espelhada'
            case 'Focus on selection': return 'Focar na seleção'
            case 'Restore camera position': return 'Restaurar posição da câmera'
            case 'Color…': return 'Cor…'
            case 'Custom…': return 'Personalizada…'
            case 'Detach from character': return 'Desconectar do personagem'
            case 'Flip': return 'Espelhar'
            case 'Place on ground': return 'Colocar no chão'
            case 'Focus': return 'Focar'
            case 'Hide': return 'Ocultar'
            case 'Show': return 'Mostrar'
            case 'Lock': return 'Bloquear'
            case 'Unlock': return 'Desbloquear'
            case 'Delete': return 'Excluir'
            case 'More': return 'Mais'
            case 'Save poses to the cloud': return 'Salve poses na nuvem'
            case 'Unlock the hand pose library': return 'Desbloqueie a biblioteca de poses de mão'
            case 'Save scenes to the cloud': return 'Salve cenas na nuvem'
            case '30+ models, including fully adjustable bodies': return 'Mais de 30 modelos, incluindo corpos totalmente ajustáveis'
            case '200+ preset poses and a hand pose library': return 'Mais de 200 poses predefinidas e uma biblioteca de poses de mão'
            case 'Prop packs, plus your own images and models': return 'Pacotes de objetos, além das suas próprias imagens e modelos'
            case 'Save poses and scenes to the cloud': return 'Salve poses e cenas na nuvem'
            case 'Export 3D models': return 'Exporte modelos 3D'
            case 'You\'ll find it in your purchase email.': return 'Você a encontra no e-mail da sua compra.'
            case 'Allow exports/imports': return 'Permitir exportar/importar'
            // Tooltips
            case 'Shapes and props': return 'Formas e figurinos'
            case 'Toggle lock camera (L)': return 'Alternar bloqueio de câmera (L)'
            case 'Toggle mirror posing mode (J)': return 'Alternar posicionamento espelhado (J)'
            case 'Options': return 'Opções'
            case 'Manipulate joints (Q)': return 'Manipular articulações (Q)'
            case 'Move objects & limbs (W)': return 'Mover objetos e membros (W)'
            case 'Scale (E)': return 'Escala (E)'
            case 'Hide tools (R)': return 'Esconder ferramentas (R)'
            case 'Poses': return 'Poses'
            case 'Scenes': return 'Cenas'
            case 'Clear scene': return 'Limpar cena'

            // Tab tooltips
            case 'Select': return 'Selecionar'
            case 'Duplicate': return 'Duplicata'
            case 'Hide toggle (H)': return 'Esconder ou mostrar (H)'
            case 'Lock toggle (K)': return 'Travar ou destravar (K)'
            case 'Attach to character': return 'Anexar a um personagem'

            // Tutorial
            case "Don't show this again": return 'Não mostre isso novamente'

            case 'Save camera position': return 'Salvar posição da câmera'
            case 'Save (hold) or restore (tap) camera position': return 'Salvar (pressionar) ou restaurar (tocar) posição da câmera'            
            case 'Lock camera': return 'Bloquear câmera'
            case 'Settings': return 'Opções'
            case 'Take screenshot': return 'Tirar captura de tela'
            
            // Character menu
            case 'Characters': return 'Personagens'
            case 'Base': return 'Base'
            case 'Stylised': return 'Estilizado'
            case 'Realistic': return 'Realista'
            case 'Fantasy': return 'Fantasia'
            case 'Other': return 'Outros'
            case 'Male': return "Homem"
            case 'Female': return "Mulher"
            case 'Adjustable male': return 'Homem ajustável'
            case 'Adjustable female': return 'Mulher ajustável'
            case 'New: Fully adjustable models': return 'Novo: modelos totalmente ajustáveis'
            case 'From limb length to hip width, sculpt any body type you can imagine.': return 'Do comprimento dos membros à largura do quadril, esculpa qualquer tipo de corpo que imaginar.'
            case 'Adjust proportions': return 'Ajustar proporções'
            case 'Scale': return 'Escala'
            case 'Teen female': return "Adolescente mulher"
            case 'Teen male': return "Adolescente homem"
            case 'Tween female': return 'Pré-adolescente mulher'
            case 'Tween male': return 'Pré-adolescente homem'
            case 'Child (older)': return 'Criança mais velha'
            case 'Child (younger)': return 'Criança mais jovem'
            case 'Baby': return 'Bebê'
            case 'Anime female v1': return 'Anime mulher v1'
            case 'Anime male v1': return 'Anime homem v1'
            case 'Anime female v2': return 'Anime mulher v2'
            case 'Anime male v2': return 'Anime homem v2'
            case 'Stylized female': return 'Mulher estilizada'
            case 'Stylized male': return 'Homem estilizado'
            case 'Chibi male': return 'Chibi homem'
            case 'Chibi female': return 'Chibi mulher'
            case 'Superhero male': return 'Super-herói homem'
            case 'Superhero female': return 'Super-herói mulher'
            case 'Chubby male': return 'Homem gordinho'
            case 'Chubby female': return 'Mulher gordinha'
            case 'Skinny male': return 'Homem magro'
            case 'Skinny female': return 'Mulher magra'
            case 'Muscular male': return 'Homem musculoso'
            case 'Muscular female': return 'Mulher musculosa'
            case 'Mermaid': return 'Sereia'
            case 'Merman': return 'Tritão'
            case 'Skeleton': return 'Esqueleto'
            case 'Dragon': return 'Dragão'
            case 'Lycan male': return 'Lobisomem'
            case 'Lycan female': return 'Lobismulher'
            case 'Art mannequin': return 'Manequim de arte'
            case 'Dog': return 'Cão'
            case 'Cat': return 'Gato'
            case 'Female v1': return 'Mulher v1'
            case 'Male v1': return 'Homem v1'
            case 'Female v2': return 'Mulher v2'
            case 'Male v2': return 'Homem v2'
            case 'Teen female v2': return 'Adolescente mulher v2'
            case 'Teen male v2': return 'Adolescente homem v2'
            case 'Tween female v2': return 'Pré-adolescente mulher v2'
            case 'Tween male v2': return 'Pré-adolescente homem v2'
            case 'Baby v2': return 'Bebê v2'
            case 'Large male': return 'Homem gordinho'
            case 'Large female': return 'Mulher gordinha'

            // Prop menu
            case 'Shapes and props': return 'Formas e figurinos'
            case 'Basic shapes': return 'Formas básicas'
            case 'Box': return 'Caixa'
            case 'Cylinder': return 'Cilindro'
            case 'Sphere': return 'Esfera'
            case 'Cone': return 'Cone'
            case 'Torus': return 'Torus'

            // Upload menu
            case 'Upload image': return 'Upload de imagem'
            case 'Upload prop (.obj)': return 'Upload de modelo (.obj)'

            // Upgrade menu
            case 'Upgrade': return 'Atualização'
            case 'Upgrade to Pro': return 'Atualizar para Pro'
            case 'Take your art to the next level!': return 'Leve sua arte para o próximo nível!'
            case 'Get JustSketchMe Pro!': return 'Obtenha o JustSketchMe Pro!'
            case 'Already have a license key?': return 'Já tem uma chave de licença?'
            case 'License key...': return 'Chave de licença...'
            case 'License key': return 'Chave de licença'
            case 'Activate': return 'Ativar'
            case 'https://justsketchme.lemonsqueezy.com/checkout/buy/24ec4be2-997a-4ed0-96e7-551c14dc1b78': return 'https://justsketchme.lemonsqueezy.com/checkout/buy/b5b4c8b8-25ba-4ae7-929a-14e313d4a291'

            case '30+ models': return '30+ modelos'
            case 'props': return 'objetos úteis'

            // Options menu
            case 'Options': return 'Opções'
            case 'Scene': return 'Centa'
            case 'Account': return 'Conta'
            case 'Dark mode': return 'Modo escuro'
            case 'Ambient lighting': return 'Iluminação ambiente'
            case 'Spot lighting': return 'Iluminação local'
            case 'Hard shadows': return 'Sombras duras '
            case 'Outline effect': return 'Efeito contorno '
            case 'Floor grid': return 'Grid do piso'
            case 'Field of view': return 'Campo de visão'
            case 'Reset light': return 'Redefinir luz'
            case 'Reset app settings': return 'Redefinir a configuração do aplicativo'
            case 'Update app': return 'Atualizar aplicativo'
            case 'Log out': return 'Sair'
            case 'Copy license key to clipboard': return 'Copiar chave de licença'
            case 'Activate up to 3 devices': return 'Ative até 3 dispositivos'
            case 'Report a bug': return 'Relatar um erro'
            case 'Suggest a feature': return 'Sugerir uma característica'
            case "A note from Herman": return "Um recado do Herman"
            case "Nothing saved yet. Strike a pose and hit Save pose.": return "Nada salvo ainda. Faça uma pose e clique em Salvar pose."
            case "No scenes yet. Set one up and hit Save scene.": return "Nenhuma cena ainda. Monte uma e clique em Salvar cena."
            case 'Documentation': return 'Documentação'
            case 'FAQ': return 'FAQ'
            case 'Manage subscription': return 'Gerenciar assinatura'

            // Pose menu
            case 'Poses': return 'Poses'
            case 'Saved poses': return 'Poses salvas'
            case "Save preset": return "Salvar predefinição"
            case "Head & neck": return "Cabeça e pescoço"
            case "Shoulders & chest": return "Ombros e peito"
            case "Arms": return "Braços"
            case "Torso & hips": return "Tronco e quadris"
            case "Legs": return "Pernas"
            case "Head": return "Cabeça"
            case "Head width": return "Largura da cabeça"
            case "Neck length": return "Comprimento do pescoço"
            case "Neck": return "Pescoço"
            case "Shoulders": return "Ombros"
            case "Shoulder angle": return "Ângulo dos ombros"
            case "Breasts": return "Seios"
            case "Breasts angle": return "Ângulo dos seios"
            case "Upper arm length": return "Comprimento do braço"
            case "Forearm length": return "Comprimento do antebraço"
            case "Torso length": return "Comprimento do tronco"
            case "Torso": return "Tronco"
            case "Belly": return "Barriga"
            case "Hips": return "Quadris"
            case "Thigh length": return "Comprimento da coxa"
            case "Shin length": return "Comprimento da canela"
            case "Feet": return "Pés"
            case "Reset sliders": return "Redefinir controles"
            case 'Pose library': return 'Biblioteca'
            case 'Save pose': return 'Salvar pose'
            case 'Open pose': return 'Abrir'
            case 'Neutral': return 'Neutro'
            case 'T pose': return 'T pose'
            case 'Save': return 'Salvar'
            case 'Category (optional)': return 'Categoria (opcional)'
            case 'Pose name': return 'Nome de pose'

            // Hand pose menu
            case 'Hand pose library': return 'Poses de mão'
            case 'Left': return 'Esq.'
            case 'Right': return 'Dir.'

            // Scene menu
            case 'Scenes': return 'Cenas'
            case 'Save scene': return 'Salvar cena'
            case 'Import scene': return 'Importar'
            case 'Name': return 'Nome'
            case 'Scene name': return 'Nome de cena'

            // Export menu

            // Messages
            case 'Internet connection required to validate key': return 'É necessária uma conexão de internet para validar a chave'
            case 'Checking license key...': return 'Verificando a chave da licença...'
            case 'This license key has expired': return 'Esta chave de licença expirou'
            case 'This license key does not exist or has expired': return 'Esta chave de licença não existe ou expirou'
            case 'No character to apply pose to': return 'Nenhum personagem para aplicar a pose'
            case '<b>Welcome to JustSketchMe Pro!</b> <br> All of the features and models have been unlocked!': return '<b>Bem-vindo ao JustSketchMe Pro!</b> <br> Todos os recursos e modelos foram desbloqueados!'
            case 'Internet connection required for cloud features': return 'É necessária uma conexão de internet para acessar os recursos na nuvem'
            case 'updated': return 'atualizada'
            case 'saved': return 'salva'
            case 'Overwrite': return 'Substituir'
            case 'Overwrite with': return 'Substituir por'
            case 'File over the': return 'Arquive acima do limite de'
            case 'limit': return ''
            case 'Failed to load': return 'Falha ao carregar'
            case 'Prop': return 'modelo'
            case 'Move to joint?': return 'Mover para articulação?'
            case 'is now attached to': return 'agora está ligado à'
            case 'Select a joint to connect': return 'Selecione uma articulação para conectar o'
            case 'has been disconnected from': return 'foi desconectado da'
            case 'Failed to load': return 'Falha ao carregar'
            case 'Are you sure you want to clear the scene?': return 'Você tem certeza de que quer desobstruir a cena?'
            case 'Exit hand editor': return "Sair do editor de mãos"
            case 'copied to clipboard': return 'copiado para a área de transferência'
            case "Loading poses...": return "Carregando poses..."
            case "Loading hand poses...": return "Carregando poses de mão..."
            case "Couldn't load all poses and props. Please reload to try again.": return "Não foi possível carregar todas as poses e figurinos. Recarregue a página para tentar novamente."

            // Untranslated strings
            case 'Export pose': return 'Exportar pose'
            case 'Export scene': return 'Exportar cena'
            case 'Adjust limb sizes (exp.)': return 'Ajustar tamanho dos membros (exp.)'
            case 'Camera position saved': return 'Posição da câmera salva'
            case '3D rendering interrupted. Restoring...': return 'Renderização 3D interrompida. Restaurando...'
            case 'Unable to reach the license service. Please try again shortly.': return 'Não foi possível acessar o serviço de licença. Tente novamente em instantes.'
            case 'Upgrade to gain access to 200+ preset poses and save your own custom poses': return 'Faça o upgrade para ter acesso a mais de 200 poses predefinidas e salvar suas próprias poses'
            case 'Upgrade to gain access to the hand pose library': return 'Faça o upgrade para ter acesso à biblioteca de poses de mão'
            case 'Upgrade to save your work in the cloud': return 'Faça o upgrade para salvar seu trabalho na nuvem'
            case 'Oh no!': return 'Ah, não!'
            case 'Something has gone terribly wrong (or the internet connection is unstable).': return 'Algo deu muito errado (ou a conexão com a internet está instável).'
            case 'Please try restarting the app.': return 'Tente reiniciar o aplicativo.'
            case 'Restart': return 'Reiniciar'
            case "If that doesn't work, ensure that your browser or app is up-to-date.": return 'Se isso não funcionar, verifique se o seu navegador ou aplicativo está atualizado.'
            case 'If you keep seeing this error please': return 'Se continuar vendo este erro,'
            case 'email us': return 'envie-nos um e-mail'
            case 'Yes': return 'Sim'
            case 'No': return 'Não'
            case 'Empty...': return 'Vazio...'
            case 'Enter your license key': return 'Digite sua chave de licença'
            case 'Copy to clipboard failed': return 'Falha ao copiar para a área de transferência'
            case 'Update payment information': return 'Atualizar informações de pagamento'
            case 'Cancel subscription': return 'Cancelar assinatura'
            case 'Warning!\n\nBy cancelling you will lose your saved data.\n\nIf you would like to pause your subscription or get a discounted rate, email us at hello@justsketch.me and we\'ll try help you out.\n\nType "yes" to confirm your cancellation.': return 'Atenção!\n\nAo cancelar, você perderá seus dados salvos.\n\nSe quiser pausar sua assinatura ou obter um preço com desconto, envie um e-mail para hello@justsketch.me e tentaremos ajudar.\n\nDigite "yes" para confirmar o cancelamento.'
            case 'Delete {name}?': return 'Excluir {name}?'
            case 'Set {file} to {character}?': return 'Aplicar {file} a {character}?'
            case '{discount}% off in {country}': return '{discount}% de desconto em {country}'
            case 'Use code {code} at checkout.': return 'Use o código {code} no checkout.'
            case 'Use code {code} at checkout on the website.': return 'Use o código {code} no checkout do site.'


            // Keyboard shortcuts list
            case 'Keyboard shortcuts': return 'Atalhos de teclado'
            case 'Rotate tool': return 'Ferramenta de rotação'
            case 'Move tool': return 'Ferramenta de mover'
            case 'Scale tool': return 'Ferramenta de escala'
            case 'Deselect, close menus, exit hand editor': return 'Desmarcar, fechar menus, sair do editor de mãos'
            case 'Orbit camera around selection': return 'Orbitar a câmera ao redor da seleção'
            case 'Hide or show selected': return 'Esconder ou mostrar o selecionado'
            case 'Lock or unlock selected': return 'Travar ou destravar o selecionado'
            case 'Place selected on ground': return 'Pôr o selecionado no chão'
            case 'Flip selected': return 'Espelhar o selecionado'
            case 'Delete selected': return 'Excluir o selecionado'
            case 'Toggle mirror posing': return 'Alternar posicionamento espelhado'
            case 'Toggle lock camera': return 'Travar ou destravar a câmera'
            case 'Undo': return 'Desfazer'
            case 'Redo': return 'Refazer'
            case 'Hide tools': return 'Esconder ferramentas'
            case 'Show this list': return 'Mostrar esta lista'

            default: lookup
        }
    }

    if (localStorage.getItem('lang') == 'es') {
        switch (lookup) {
            // Welcome and redesign popups, camera message
            case 'A simpler JustSketchMe': return 'Un JustSketchMe más sencillo'
            case 'I\'ve reorganised everything around a classic menu bar, so each tool has a clear name instead of an icon you have to guess at. Everything is still here, just easier to find.': return 'He reorganizado todo en torno a una barra de menús clásica, para que cada herramienta tenga un nombre claro en lugar de un icono que tengas que adivinar. Todo sigue aquí, solo que más fácil de encontrar.'
            case 'Your basic tools are in the top right (or bottom center on mobile). The rest of the menus should be self-explanatory.': return 'Tus herramientas básicas están arriba a la derecha (o abajo en el centro en el móvil). El resto de los menús deberían explicarse solos.'
            case 'This update was a long time in the making, picked up and put down many times over the years. I hope you enjoy the updates! Please': return 'Esta actualización llevó mucho tiempo, retomada y dejada de lado muchas veces a lo largo de los años. ¡Espero que disfrutes las novedades! Por favor,'
            case 'contact me': return 'contáctame'
            case 'if you run into any issues.': return 'si tienes algún problema.'
            case 'Got it': return 'Entendido'
            case 'Welcome to JustSketchMe': return 'Bienvenido a JustSketchMe'
            case 'Pose': return 'Posar'
            case 'Rotate:': return 'Rotar:'
            case 'drag a coloured dot to rotate that joint.': return 'arrastra un punto de color para rotar esa articulación.'
            case 'Move:': return 'Mover:'
            case 'drag to move a character, prop or limb.': return 'arrastra para mover un personaje, objeto o extremidad.'
            case 'Scale:': return 'Escala:'
            case 'drag to make an object bigger or smaller.': return 'arrastra para hacer un objeto más grande o más pequeño.'
            case 'Hide tools:': return 'Ocultar herramientas:'
            case 'hides the dots for a clean view of your pose.': return 'oculta los puntos para ver tu pose sin distracciones.'
            case 'Move around': return 'Moverse por la escena'
            case 'Orbit:': return 'Orbitar:'
            case 'drag the background, or drag with one finger.': return 'arrastra el fondo, o arrastra con un dedo.'
            case 'Pan:': return 'Desplazar:'
            case 'right-drag, or drag with two fingers.': return 'arrastra con el botón derecho, o arrastra con dos dedos.'
            case 'Zoom:': return 'Zoom:'
            case 'scroll, or pinch.': return 'usa la rueda del ratón, o pellizca.'
            case 'Select and modify characters': return 'Seleccionar y modificar personajes'
            case 'Each character has a tab in the top left. Click it to select that character.': return 'Cada personaje tiene una pestaña arriba a la izquierda. Haz clic en ella para seleccionar ese personaje.'
            case 'Click the': return 'Haz clic en el'
            case 'on a tab (or right-click it) to change colour, duplicate, flip, hide, lock or delete.': return 'de una pestaña (o haz clic derecho en ella) para cambiar el color, duplicar, voltear, ocultar, bloquear o eliminar.'
            case 'Add things': return 'Añadir cosas'
            case 'Use the menu bar to add characters and props, apply poses and hand poses, and export a screenshot.': return 'Usa la barra de menús para añadir personajes y objetos, aplicar poses y poses de mano, y exportar una captura de pantalla.'
            case 'Start posing': return 'Empezar a posar'
            case 'Getting started': return 'Primeros pasos'
            case 'Back to the starting view. Hold the camera button to save your own.': return 'De vuelta a la vista inicial. Mantén pulsado el botón de la cámara para guardar la tuya.'

            // Menu bar, object menus and upgrade panel
            case 'Unlock the prop library': return 'Desbloquea la biblioteca de objetos'
            case 'Unlock the pose library': return 'Desbloquea la biblioteca de poses'
            case 'Export 3D model': return 'Exportar modelo 3D'
            case 'Upload prop': return 'Cargar accesorio'
            case 'Show 3D gizmo': return 'Mostrar gizmo 3D'
            case 'Version': return 'Versión'
            case 'View': return 'Ver'
            case 'Edit': return 'Editar'
            case 'Props': return 'Objetos'
            case 'Hands': return 'Manos'
            case 'Export': return 'Exportar'
            case 'Help': return 'Ayuda'
            case 'Rotate': return 'Rotar'
            case 'Move': return 'Mover'
            case 'Mirror posing': return 'Pose en espejo'
            case 'Focus on selection': return 'Enfocar la selección'
            case 'Restore camera position': return 'Restaurar posición de la cámara'
            case 'Color…': return 'Color…'
            case 'Custom…': return 'Personalizado…'
            case 'Detach from character': return 'Separar del personaje'
            case 'Flip': return 'Voltear'
            case 'Place on ground': return 'Colocar en el suelo'
            case 'Focus': return 'Enfocar'
            case 'Hide': return 'Ocultar'
            case 'Show': return 'Mostrar'
            case 'Lock': return 'Bloquear'
            case 'Unlock': return 'Desbloquear'
            case 'Delete': return 'Eliminar'
            case 'More': return 'Más'
            case 'Save poses to the cloud': return 'Guarda poses en la nube'
            case 'Unlock the hand pose library': return 'Desbloquea la biblioteca de poses de manos'
            case 'Save scenes to the cloud': return 'Guarda escenas en la nube'
            case '30+ models, including fully adjustable bodies': return 'Más de 30 modelos, incluidos cuerpos totalmente ajustables'
            case '200+ preset poses and a hand pose library': return 'Más de 200 poses predefinidas y una biblioteca de poses de manos'
            case 'Prop packs, plus your own images and models': return 'Paquetes de objetos, además de tus propias imágenes y modelos'
            case 'Save poses and scenes to the cloud': return 'Guarda poses y escenas en la nube'
            case 'Export 3D models': return 'Exporta modelos 3D'
            case 'You\'ll find it in your purchase email.': return 'La encontrarás en el correo de tu compra.'
            case 'Allow exports/imports': return 'Permitir exportar/importar'
            // Tooltips
            case 'Shapes and props': return 'Formas y accesorios'
            case 'Toggle lock camera (L)': return 'Bloquear/Desbloquear cámara (L)'
            case 'Toggle mirror posing mode (J)': return 'Alternar posado espejo (J)'
            case 'Options': return 'Opciones'
            case 'Manipulate joints (Q)': return 'Manipular articulaciones (Q)'
            case 'Move objects & limbs (W)': return 'Mover objetos y extremidades (W)'
            case 'Scale (E)': return 'Escalar (E)'
            case 'Hide tools (R)': return 'Ocultar herramientas (R)'
            case 'Poses': return 'Poses'
            case 'Scenes': return 'Escenas'
            case 'Clear scene': return 'Borrar escena'

            // Tab tooltips
            case 'Select': return 'Seleccionar'
            case 'Duplicate': return 'Duplicar'
            case 'Hide toggle (H)': return 'Ocultar (H)'
            case 'Lock toggle (K)': return 'Bloquear (K)'
            case 'Attach to character': return 'Adjuntar al personaje'

            // Tutorial
            case "Don't show this again": return 'No volver a mostrar'

            case 'Save camera position': return 'Posición de la cámara'
            case 'Save (hold) or restore (tap) camera position': return 'Guardar (mantener) o restaurar (tocar) posición de la cámara'
            case 'Lock camera': return 'Bloquear cámara'
            case 'Settings': return 'Ajustes'
            case 'Take screenshot': return 'Tomar captura de pantalla'
            
            // Character menu
            case 'Characters': return 'Personajes'
            case 'Base': return 'Base'
            case 'Stylised': return 'Estilizado'
            case 'Realistic': return 'Realista'
            case 'Fantasy': return 'Fantástico'
            case 'Other': return 'Otros'
            case 'Male': return "Hombre"
            case 'Female': return "Mujer"
            case 'Adjustable male': return 'Hombre ajustable'
            case 'Adjustable female': return 'Mujer ajustable'
            case 'New: Fully adjustable models': return 'Nuevo: modelos totalmente ajustables'
            case 'From limb length to hip width, sculpt any body type you can imagine.': return 'Desde el largo de las extremidades hasta el ancho de cadera, esculpe cualquier tipo de cuerpo que imagines.'
            case 'Adjust proportions': return 'Ajustar proporciones'
            case 'Scale': return 'Escala'
            case 'Teen female': return "Adolescente femenino"
            case 'Teen male': return "Adolescente masculino"
            case 'Tween female': return 'Preadolescente femenino'
            case 'Tween male': return 'Preadolescente masculino'
            case 'Child (older)': return 'Niño (mayor)'
            case 'Child (younger)': return 'Niño (menor)'
            case 'Baby': return 'Bebé'
            case 'Anime female v1': return 'Anime femenino v1'
            case 'Anime male v1': return 'Anime masculino v1'
            case 'Anime female v2': return 'Anime femenino v2'
            case 'Anime male v2': return 'Anime masculino v2'
            case 'Stylized female': return 'Mujer estilizada'
            case 'Stylized male': return 'Hombre estilizado'
            case 'Chibi male': return 'Chibi masculino'
            case 'Chibi female': return 'Chibi femenino'
            case 'Superhero male': return 'Superhéroe'
            case 'Superhero female': return 'Superheroína'
            case 'Chubby male': return 'Hombre rechoncho'
            case 'Chubby female': return 'Mujer rechoncha'
            case 'Skinny male': return 'Hombre delgado'
            case 'Skinny female': return 'Mujer delgada'
            case 'Muscular male': return 'Hombre musculoso'
            case 'Muscular female': return 'Mujer musculosa'
            case 'Mermaid': return 'Sirena'
            case 'Merman': return 'Hombre sirena'
            case 'Skeleton': return 'Esqueleto'
            case 'Dragon': return 'Dragón'
            case 'Lycan male': return 'Licántropo'
            case 'Lycan female': return 'Licántropa'
            case 'Art mannequin': return 'Maniquí artístico'
            case 'Dog': return 'Perro'
            case 'Cat': return 'Gato'
            case 'Female v1': return 'Mujer v1'
            case 'Male v1': return 'Hombre v1'
            case 'Female v2': return 'Mujer v2'
            case 'Male v2': return 'Hombre v2'
            case 'Teen female v2': return 'Adolescente femenino v2'
            case 'Teen male v2': return 'Adolescente masculino v2'
            case 'Tween female v2': return 'Preadolescente femenino v2'
            case 'Tween male v2': return 'Preadolescente masculino v2'
            case 'Baby v2': return 'Bebé v2'
            case 'Large male': return 'Hombre grande'
            case 'Large female': return 'Mujer grande'

            // Prop menu
            case 'Shapes and props': return 'Formas y accesorios'
            case 'Basic shapes': return 'Formas básicas'
            case 'Box': return 'Caja'
            case 'Cylinder': return 'Cilindro'
            case 'Sphere': return 'Esfera'
            case 'Cone': return 'Cono'
            case 'Torus': return 'Toro'
            case '': return ''

            // Upload menu
            case 'Upload image': return 'Cargar imagen'
            case 'Upload prop (.obj)': return 'Cargar accesorio (.obj)'

            // Upgrade menu
            case 'Upgrade': return 'Mejorar'
            case 'Upgrade to Pro': return 'Mejorar a Pro'
            case 'Take your art to the next level!': return '¡Lleva tu arte un paso más allá!'
            case 'Get JustSketchMe Pro!': return '¡Hazte con JustSketchMe Pro!'
            case 'Already have a license key?': return '¿Ya tienes una clave de licencia?'
            case 'License key...': return 'Clave de licencia...'
            case 'License key': return 'Clave de licencia'
            case 'Activate': return 'Activar'
            case 'https://justsketchme.lemonsqueezy.com/checkout/buy/24ec4be2-997a-4ed0-96e7-551c14dc1b78': return 'https://justsketchme.lemonsqueezy.com/checkout/buy/254e3a2d-7c36-4cff-adff-035ac55e4053'

            case '30+ models': return 'más de 30 modelos'
            case 'props': return 'accesorios'

            // Options menu
            case 'Options': return 'Opciones'
            case 'Scene': return 'Escena'
            case 'Account': return 'Cuenta'
            case 'Dark mode': return 'Modo oscuro'
            case 'Ambient lighting': return 'Iluminación ambiental'
            case 'Spot lighting': return 'Iluminación por puntos'
            case 'Hard shadows': return 'Luz dura'
            case 'Outline effect': return 'Efecto contorno'
            case 'Floor grid': return 'Rejilla en suelo'
            case 'Field of view': return 'Campo de visión'
            case 'Reset light': return 'Restaurar luz'
            case 'Reset app settings': return 'Restablecer ajustes'
            case 'Update app': return 'Actualizar app'
            case 'Log out': return 'Cerrar sesión'
            case 'Copy license key to clipboard': return 'Copiar clave de licencia'
            case 'Activate up to 3 devices': return 'Activa hasta 3 dispositivos'
            case 'Report a bug': return 'Informar de un error'
            case 'Suggest a feature': return 'Sugerir una funcionalidad'
            case "A note from Herman": return "Una nota de Herman"
            case "Nothing saved yet. Strike a pose and hit Save pose.": return "Nada guardado todavía. Haz una pose y pulsa Guardar pose."
            case "No scenes yet. Set one up and hit Save scene.": return "Aún no hay escenas. Monta una y pulsa Guardar escena."
            case 'Documentation': return 'Documentación'
            case 'FAQ': return 'Preguntas frecuentes'
            case 'Manage subscription': return 'Gestionar suscripción'

            // Pose menu
            case 'Poses': return 'Poses'
            case 'Saved poses': return 'Poses guardadas'
            case "Save preset": return "Guardar preajuste"
            case "Head & neck": return "Cabeza y cuello"
            case "Shoulders & chest": return "Hombros y pecho"
            case "Arms": return "Brazos"
            case "Torso & hips": return "Torso y caderas"
            case "Legs": return "Piernas"
            case "Head": return "Cabeza"
            case "Head width": return "Ancho de cabeza"
            case "Neck length": return "Largo del cuello"
            case "Neck": return "Cuello"
            case "Shoulders": return "Hombros"
            case "Shoulder angle": return "Ángulo de hombros"
            case "Breasts": return "Pechos"
            case "Breasts angle": return "Ángulo de pechos"
            case "Upper arm length": return "Largo del brazo"
            case "Forearm length": return "Largo del antebrazo"
            case "Torso length": return "Largo del torso"
            case "Torso": return "Torso"
            case "Belly": return "Vientre"
            case "Hips": return "Caderas"
            case "Thigh length": return "Largo del muslo"
            case "Shin length": return "Largo de la espinilla"
            case "Feet": return "Pies"
            case "Reset sliders": return "Restablecer controles"
            case 'Pose library': return 'Biblioteca'
            case 'Save pose': return 'Guardar pose'
            case 'Open pose': return 'Abrir'
            case 'Neutral': return 'Neutral'
            case 'T pose': return 'Pose en T'
            case 'Save': return 'Guardar'
            case 'Category (optional)': return 'Categoría (opcional)'
            case 'Pose name': return 'Nombre de la pose'

            // Hand pose menu
            case 'Hand pose library': return 'Poses de manos'
            case 'Left': return 'Izq.'
            case 'Right': return 'Der.'

            // Scene menu
            case 'Scenes': return 'Escenas'
            case 'Save scene': return 'Guardar escena'
            case 'Import scene': return 'Importar'
            case 'Name': return 'Nombre'
            case 'Scene name': return 'Nombre de la escena'

            // Export menu

            // Messages
            case 'Internet connection required to validate key': return 'Se requiere conexión a Internet para validar la clave'
            case 'Checking license key...': return 'Verificando la clave de licencia...'
            case 'This license key has expired': return 'Esta clave de licencia ha expirado'
            case 'This license key does not exist or has expired': return 'Esta clave de licencia no existe o ha expirado'
            case 'No character to apply pose to': return 'No hay personaje al que aplicar la pose'
            case '<b>Welcome to JustSketchMe Pro!</b> <br> All of the features and models have been unlocked!': return '<b>¡Bienvenido a JustSketchMe Pro!</b> <br> ¡Todas las funcionalidades y modelos han sido desbloqueados!'
            case 'Internet connection required for cloud features': return 'Se requiere conexión a Internet para acceder a las funciones de la nube'
            case 'updated': return 'actualizado'
            case 'saved': return 'guardado'
            case 'Overwrite': return 'Sobrescribir'
            case 'Overwrite with': return 'Sobrescribir con'
            case 'File over the': return 'Archivo por encima del'
            case 'limit': return 'límite'
            case 'Failed to load': return 'Error al cargar'
            case 'Prop': return 'Acccesorio'
            case 'Move to joint?': return '¿Pasar a la articulación?'
            case 'is now attached to': return 'ahora está adjunto a'
            case 'Select a joint to connect': return 'Selecciona una articulación para conectar'
            case 'has been disconnected from': return 'se ha desconectado de'
            case 'Failed to load': return 'Error al cargar'
            case 'Are you sure you want to clear the scene?': return '¿Seguro que deseas borrar la escena?'
            case 'Exit hand editor': return "Cerrar editor de manos"
            case 'copied to clipboard': return 'copiado al portapapeles'
            case "Loading poses...": return "Cargando poses..."
            case "Loading hand poses...": return "Cargando poses de manos..."
            case "Couldn't load all poses and props. Please reload to try again.": return "No se pudieron cargar todas las poses y accesorios. Vuelve a cargar la página para intentarlo de nuevo."

            // Untranslated strings
            case 'Export pose': return 'Exportar pose'
            case 'Export scene': return 'Exportar escena'
            case 'Adjust limb sizes (exp.)': return 'Ajustar tamaño de extremidades (exp.)'
            case 'Camera position saved': return 'Posición de cámara guardada'
            case '3D rendering interrupted. Restoring...': return 'Renderizado 3D interrumpido. Restaurando...'
            case 'Unable to reach the license service. Please try again shortly.': return 'No se pudo contactar con el servicio de licencias. Inténtalo de nuevo en breve.'
            case 'Upgrade to gain access to 200+ preset poses and save your own custom poses': return 'Mejora para acceder a más de 200 poses predefinidas y guardar tus propias poses'
            case 'Upgrade to gain access to the hand pose library': return 'Mejora para acceder a la biblioteca de poses de manos'
            case 'Upgrade to save your work in the cloud': return 'Mejora para guardar tu trabajo en la nube'
            case 'Oh no!': return '¡Oh no!'
            case 'Something has gone terribly wrong (or the internet connection is unstable).': return 'Algo ha salido muy mal (o la conexión a internet es inestable).'
            case 'Please try restarting the app.': return 'Intenta reiniciar la aplicación.'
            case 'Restart': return 'Reiniciar'
            case "If that doesn't work, ensure that your browser or app is up-to-date.": return 'Si eso no funciona, asegúrate de que tu navegador o aplicación estén actualizados.'
            case 'If you keep seeing this error please': return 'Si sigues viendo este error, por favor'
            case 'email us': return 'escríbenos un correo'
            case 'Yes': return 'Sí'
            case 'No': return 'No'
            case 'Empty...': return 'Vacío...'
            case 'Enter your license key': return 'Introduce tu clave de licencia'
            case 'Copy to clipboard failed': return 'No se pudo copiar al portapapeles'
            case 'Update payment information': return 'Actualizar información de pago'
            case 'Cancel subscription': return 'Cancelar suscripción'
            case 'Warning!\n\nBy cancelling you will lose your saved data.\n\nIf you would like to pause your subscription or get a discounted rate, email us at hello@justsketch.me and we\'ll try help you out.\n\nType "yes" to confirm your cancellation.': return '¡Atención!\n\nAl cancelar perderás tus datos guardados.\n\nSi quieres pausar tu suscripción u obtener un precio con descuento, escríbenos a hello@justsketch.me e intentaremos ayudarte.\n\nEscribe "yes" para confirmar la cancelación.'
            case 'Delete {name}?': return '¿Eliminar {name}?'
            case 'Set {file} to {character}?': return '¿Aplicar {file} a {character}?'
            case '{discount}% off in {country}': return '{discount}% de descuento en {country}'
            case 'Use code {code} at checkout.': return 'Usa el código {code} al pagar.'
            case 'Use code {code} at checkout on the website.': return 'Usa el código {code} al pagar en el sitio web.'


            // Keyboard shortcuts list
            case 'Keyboard shortcuts': return 'Atajos de teclado'
            case 'Rotate tool': return 'Herramienta de rotación'
            case 'Move tool': return 'Herramienta de mover'
            case 'Scale tool': return 'Herramienta de escala'
            case 'Deselect, close menus, exit hand editor': return 'Deseleccionar, cerrar menús, salir del editor de manos'
            case 'Orbit camera around selection': return 'Orbitar la cámara alrededor de la selección'
            case 'Hide or show selected': return 'Ocultar o mostrar la selección'
            case 'Lock or unlock selected': return 'Bloquear o desbloquear la selección'
            case 'Place selected on ground': return 'Colocar la selección en el suelo'
            case 'Flip selected': return 'Voltear la selección'
            case 'Delete selected': return 'Borrar la selección'
            case 'Toggle mirror posing': return 'Alternar posado espejo'
            case 'Toggle lock camera': return 'Bloquear o desbloquear la cámara'
            case 'Undo': return 'Deshacer'
            case 'Redo': return 'Rehacer'
            case 'Hide tools': return 'Ocultar herramientas'
            case 'Show this list': return 'Mostrar esta lista'

            default: lookup
        }
    }

    if (localStorage.getItem('lang') == 'ja') {
        switch (lookup) {
            // Welcome and redesign popups, camera message
            case 'A simpler JustSketchMe': return 'よりシンプルなJustSketchMe'
            case 'I\'ve reorganised everything around a classic menu bar, so each tool has a clear name instead of an icon you have to guess at. Everything is still here, just easier to find.': return 'すべてをクラシックなメニューバーにまとめ直しました。アイコンから推測しなくても、各ツールに分かりやすい名前が付いています。機能はすべてそのままで、見つけやすくなっただけです。'
            case 'Your basic tools are in the top right (or bottom center on mobile). The rest of the menus should be self-explanatory.': return '基本ツールは右上（モバイルでは下の中央）にあります。その他のメニューは見ればわかるはずです。'
            case 'This update was a long time in the making, picked up and put down many times over the years. I hope you enjoy the updates! Please': return 'このアップデートは長い時間をかけ、何年もの間、何度も手を付けては中断してきたものです。楽しんでいただけたら嬉しいです！'
            case 'contact me': return 'お問い合わせ'
            case 'if you run into any issues.': return 'から、問題があればご連絡ください。'
            case 'Got it': return 'OK'
            case 'Welcome to JustSketchMe': return 'JustSketchMeへようこそ'
            case 'Pose': return 'ポーズ'
            case 'Rotate:': return '回転：'
            case 'drag a coloured dot to rotate that joint.': return '色付きの点をドラッグして、その関節を回転します。'
            case 'Move:': return '移動：'
            case 'drag to move a character, prop or limb.': return 'ドラッグしてキャラクター、小道具、手足を移動します。'
            case 'Scale:': return '拡大縮小：'
            case 'drag to make an object bigger or smaller.': return 'ドラッグしてオブジェクトを大きく、または小さくします。'
            case 'Hide tools:': return 'ツールを隠す：'
            case 'hides the dots for a clean view of your pose.': return '点を隠して、ポーズをすっきり確認できます。'
            case 'Move around': return '視点の操作'
            case 'Orbit:': return '視点の回転：'
            case 'drag the background, or drag with one finger.': return '背景をドラッグ、または1本指でドラッグします。'
            case 'Pan:': return 'パン：'
            case 'right-drag, or drag with two fingers.': return '右ドラッグ、または2本指でドラッグします。'
            case 'Zoom:': return 'ズーム：'
            case 'scroll, or pinch.': return 'スクロール、またはピンチします。'
            case 'Select and modify characters': return 'キャラクターの選択と編集'
            case 'Each character has a tab in the top left. Click it to select that character.': return '各キャラクターには左上にタブがあります。クリックするとそのキャラクターを選択できます。'
            case 'Click the': return 'タブの'
            case 'on a tab (or right-click it) to change colour, duplicate, flip, hide, lock or delete.': return 'をクリック（または右クリック）すると、色の変更、複製、反転、非表示、ロック、削除ができます。'
            case 'Add things': return '追加する'
            case 'Use the menu bar to add characters and props, apply poses and hand poses, and export a screenshot.': return 'メニューバーから、キャラクターや小道具の追加、ポーズや手のポーズの適用、スクリーンショットの書き出しができます。'
            case 'Start posing': return 'ポーズを始める'
            case 'Getting started': return 'はじめに'
            case 'Back to the starting view. Hold the camera button to save your own.': return '初期の視点に戻りました。カメラボタンを長押しすると、自分の視点を保存できます。'

            // Menu bar, object menus and upgrade panel
            case 'Unlock the prop library': return '小道具ライブラリーを解除'
            case 'Unlock the pose library': return 'ポーズライブラリーを解除'
            case 'Export 3D model': return '3Dモデルをエクスポート'
            case 'Upload prop': return '小道具をアップロード'
            case 'Show 3D gizmo': return '3Dギズモを表示'
            case 'Version': return 'バージョン'
            case 'View': return '表示'
            case 'Edit': return '編集'
            case 'Props': return '小道具'
            case 'Hands': return '手'
            case 'Export': return 'エクスポート'
            case 'Help': return 'ヘルプ'
            case 'Rotate': return '回転'
            case 'Move': return '移動'
            case 'Mirror posing': return 'ミラーポーズ'
            case 'Focus on selection': return '選択項目にフォーカス'
            case 'Restore camera position': return 'カメラ位置を復元'
            case 'Color…': return '色…'
            case 'Custom…': return 'カスタム…'
            case 'Detach from character': return 'キャラクターから外す'
            case 'Flip': return '反転'
            case 'Place on ground': return '地面に置く'
            case 'Focus': return 'フォーカス'
            case 'Hide': return '非表示'
            case 'Show': return '表示'
            case 'Lock': return 'ロック'
            case 'Unlock': return 'ロック解除'
            case 'Delete': return '削除'
            case 'More': return 'その他'
            case 'Save poses to the cloud': return 'ポーズをクラウドに保存'
            case 'Unlock the hand pose library': return 'ハンドポーズライブラリーを解除'
            case 'Save scenes to the cloud': return 'シーンをクラウドに保存'
            case '30+ models, including fully adjustable bodies': return '完全に調整可能な体型を含む30以上のモデル'
            case '200+ preset poses and a hand pose library': return '200以上のプリセットポーズとハンドポーズライブラリー'
            case 'Prop packs, plus your own images and models': return '小道具パック、さらに自分の画像やモデル'
            case 'Save poses and scenes to the cloud': return 'ポーズとシーンをクラウドに保存'
            case 'Export 3D models': return '3Dモデルをエクスポート'
            case 'You\'ll find it in your purchase email.': return '購入時のメールに記載されています。'
            case 'Allow exports/imports': return 'エクスポート/インポートを許可'
            // Tooltips
            case 'Shapes and props': return 'シェイプと小道具'
            case 'Toggle lock camera (L)': return 'カメラロックの切り替え (L)'
            case 'Toggle mirror posing mode (J)': return 'ミラーポーズの切り替え (J)'
            case 'Options': return 'オプション'
            case 'Manipulate joints (Q)': return 'ジョイントを操作する (Q)'
            case 'Move objects & limbs (W)': return 'オブジェクトと手足の移動 (W)'
            case 'Scale (E)': return '拡大縮小 (E)'
            case 'Hide tools (R)': return 'ツールを隠す (R)'
            case 'Poses': return 'ポーズ'
            case 'Scenes': return 'シーン'
            case 'Clear scene': return 'シーンを消去'

            // Tab tooltips
            case 'Select': return '選択'
            case 'Duplicate': return '複製'
            case 'Hide toggle (H)': return 'トグルを隠す (H)'
            case 'Lock toggle (K)': return 'トグルをロック (K)'
            case 'Attach to character': return 'キャラクターへのアタッチメント'

            // Tutorial
            case "Don't show this again": return '今後は表示しない'
            
            case 'Save camera position': return 'カメラの位置を保存する'
            case 'Save (hold) or restore (tap) camera position': return 'カメラの位置を保存する（長押し）または復元する（タップ）'
            case 'Lock camera': return 'ミラーポーズモード'
            case 'Settings': return '設定'
            case 'Take screenshot': return 'スクリーンショットを撮ります'
            
            // Character menu
            case 'Characters': return 'キャラクター'
            case 'Base': return '基本'
            case 'Stylised': return 'スタイライズド'
            case 'Realistic': return 'リアル'
            case 'Fantasy': return 'ファンタジー'
            case 'Other': return 'その他'
            case 'Male': return "男"
            case 'Female': return "女"
            case 'Adjustable male': return '調整可能な男性'
            case 'Adjustable female': return '調整可能な女性'
            case 'New: Fully adjustable models': return '新機能：完全に調整可能なモデル'
            case 'From limb length to hip width, sculpt any body type you can imagine.': return '手足の長さから腰幅まで、思い描くどんな体型も作れます。'
            case 'Adjust proportions': return 'プロポーションを調整'
            case 'Scale': return '拡大縮小'
            case 'Teen female': return "ティーン 女"
            case 'Teen male': return "ティーン 男"
            case 'Tween female': return 'トゥイーン 女'
            case 'Tween male': return 'トゥイーン 男'
            case 'Child (older)': return 'こども (大きい)'
            case 'Child (younger)': return 'こども (小さい)'
            case 'Baby': return '赤ちゃん'
            case 'Anime female v1': return 'アニメ 女 v1'
            case 'Anime male v1': return 'アニメ 男 v1'
            case 'Anime female v2': return 'アニメ 女 v2'
            case 'Anime male v2': return 'アニメ 男 v2'
            case 'Stylized female': return 'スタイライズド 女'
            case 'Stylized male': return 'スタイライズド 男'
            case 'Chibi male': return 'チビ 男'
            case 'Chibi female': return 'チビ 女'
            case 'Superhero male': return 'スーパーヒーロー 男'
            case 'Superhero female': return 'スーパーヒーロー 女'
            case 'Chubby male': return 'ポッチャリ 男'
            case 'Chubby female': return 'ポッチャリ 女'
            case 'Skinny male': return 'やせ型 男'
            case 'Skinny female': return 'やせ型 女'
            case 'Muscular male': return '筋肉質 男'
            case 'Muscular female': return '筋肉質 女'
            case 'Mermaid': return '人魚 女'
            case 'Merman': return '人魚 男'
            case 'Skeleton': return 'スケルトン'
            case 'Dragon': return 'ドラゴン'
            case 'Lycan male': return 'オオカミ人間 男'
            case 'Lycan female': return 'オオカミ人間 女'
            case 'Art mannequin': return 'アートマネキン'
            case 'Dog': return '犬'
            case 'Cat': return '猫'
            case 'Female v1': return '女 v1'
            case 'Male v1': return '男 v1'
            case 'Female v2': return '女 v2'
            case 'Male v2': return '男 v2'
            case 'Teen female v2': return 'ティーン 女 v2'
            case 'Teen male v2': return 'ティーン 男 v2'
            case 'Tween female v2': return 'トゥイーン 女 v2'
            case 'Tween male v2': return 'トゥイーン 男 v2'
            case 'Baby v2': return '赤ちゃん v2'
            case 'Large male': return '特大 男 (ベータ)'
            case 'Large female': return '特大 女 (ベータ)'

            // Prop menu
            case 'Shapes and props': return 'シェイプと小道具'
            case 'Basic shapes': return '基本図形'
            case 'Box': return '箱'
            case 'Cylinder': return '円柱'
            case 'Sphere': return '球体'
            case 'Cone': return '円錐'
            case 'Torus': return '輪'

            // Upload menu
            case 'Upload image': return '画像のアップロード'
            case 'Upload prop (.obj)': return '小道具 (.obj) をアップロードする'

            // Upgrade menu
            case 'Upgrade': return 'アップグレード'
            case 'Upgrade to Pro': return 'Proにアップグレード'
            case 'Take your art to the next level!': return 'あなたのアートを次のレベルへ！'
            case 'Get JustSketchMe Pro!': return 'JustSketchMe Proをゲットしよう!'
            case 'Already have a license key?': return 'すでにライセンスキーを持ってる？'
            case 'License key...': return 'ライセンスキー...'
            case 'License key': return 'ライセンスキー'
            case 'Activate': return 'アクティベート'
            case 'https://justsketchme.lemonsqueezy.com/checkout/buy/24ec4be2-997a-4ed0-96e7-551c14dc1b78': return 'https://justsketchme.lemonsqueezy.com/checkout/buy/6657d262-1aee-4f39-94cb-d0ace6c36242'

            case '30+ models': return '30以上のモデル'
            case 'props': return '小道具'

            // Options menu
            case 'Options': return 'オプション'
            case 'Scene': return 'シーン'
            case 'Account': return 'アカウント'
            case 'Dark mode': return 'ダークモード'
            case 'Ambient lighting': return 'アンビエント照明'
            case 'Spot lighting': return 'スポット照明'
            case 'Hard shadows': return 'ハードシャドウ'
            case 'Outline effect': return 'アウトライン効果'
            case 'Floor grid': return 'フロアグリッド'
            case 'Field of view': return '視界'
            case 'Reset light': return 'ライトのリセット'
            case 'Reset app settings': return 'アプリの設定をリセット'
            case 'Update app': return 'アプリのアップデート'
            case 'Log out': return 'ログアウト'
            case 'Copy license key to clipboard': return 'ライセンスキーをコピー'
            case 'Activate up to 3 devices': return '最大3台のデバイスで有効化'
            case 'Report a bug': return 'バグを報告'
            case 'Suggest a feature': return '機能を提案'
            case "A note from Herman": return "Hermanからのメッセージ"
            case "Nothing saved yet. Strike a pose and hit Save pose.": return "まだ保存されていません。ポーズを決めて「ポーズを保存」を押してください。"
            case "No scenes yet. Set one up and hit Save scene.": return "まだシーンがありません。シーンを作って「シーンの保存」を押してください。"
            case 'Documentation': return 'ドキュメンテーション'
            case 'FAQ': return 'FAQ'
            case 'Manage subscription': return 'サブスクリプションの管理'

            // Pose menu
            case 'Poses': return 'ポーズ'
            case 'Saved poses': return '保存したポーズ'
            case "Save preset": return "プリセットを保存"
            case "Head & neck": return "頭と首"
            case "Shoulders & chest": return "肩と胸"
            case "Arms": return "腕"
            case "Torso & hips": return "胴と腰"
            case "Legs": return "脚"
            case "Head": return "頭"
            case "Head width": return "頭の幅"
            case "Neck length": return "首の長さ"
            case "Neck": return "首"
            case "Shoulders": return "肩"
            case "Shoulder angle": return "肩の角度"
            case "Breasts": return "胸"
            case "Breasts angle": return "胸の角度"
            case "Upper arm length": return "上腕の長さ"
            case "Forearm length": return "前腕の長さ"
            case "Torso length": return "胴の長さ"
            case "Torso": return "胴"
            case "Belly": return "お腹"
            case "Hips": return "腰"
            case "Thigh length": return "太ももの長さ"
            case "Shin length": return "すねの長さ"
            case "Feet": return "足"
            case "Reset sliders": return "スライダーをリセット"
            case 'Pose library': return 'ポーズライブラリー'
            case 'Save pose': return 'ポーズを保存'
            case 'Open pose': return 'ポーズを開く'
            case 'Neutral': return 'ニュートラル'
            case 'T pose': return 'Tポーズ'
            case 'Save': return '保存'
            case 'Category (optional)': return 'カテゴリー (オプション)'
            case 'Pose name': return 'ポーズ名'

            // Hand pose menu
            case 'Hand pose library': return 'ハンドポーズライブラリー'
            case 'Left': return '左'
            case 'Right': return '右'

            // Scene menu
            case 'Scenes': return 'シーン'
            case 'Save scene': return 'シーンの保存'
            case 'Import scene': return 'シーンのインポート'
            case 'Name': return '名前'
            case 'Scene name': return 'シーン名'

            // Export menu

            // Messages
            case 'Internet connection required to validate key': return 'キー認証にインターネット接続が必要です'
            case 'Checking license key...': return 'ライセンスキーを確認中...'
            case 'This license key has expired': return 'このライセンスキーは有効期限が切れています'
            case 'This license key does not exist or has expired': return 'このライセンスキーは存在しないか有効期限が切れています'
            case 'No character to apply pose to': return 'ポーズを適用するキャラクターがいません'
            case '<b>Welcome to JustSketchMe Pro!</b> <br> All of the features and models have been unlocked!': return '<b>JustSketchMe Proへようこそ!</b> <br>すべての機能とモデルがアンロックされました！'
            case 'Internet connection required for cloud features': return 'クラウド機能にはインターネット接続が必要です'
            case 'updated': return 'アップデートされた'
            case 'saved': return '保存された'
            case 'Overwrite': return '上書き保存'
            case 'Overwrite with': return '上書き保存'
            case 'File over the': return ''
            case 'limit': return 'を超えたファイル上限'
            case 'Failed to load': return '読み込みに失敗しました'
            case 'Move to joint?': return 'ジョイントに移動しますか？'
            case 'Prop': return '小道具'
            case 'is now attached to': return '接続済み'
            case 'Select a joint to connect': return '接続するジョイントを選択する'
            case 'has been disconnected from': return '切断された'
            case 'Failed to load': return '読み込みに失敗しました'
            case 'Are you sure you want to clear the scene?': return '本当にシーンを消去しますか？'
            case 'Exit hand editor': return "ハンドエディターを終了"
            case 'copied to clipboard': return '- クリップボードにコピーされました'
            case "Loading poses...": return "ポーズを読み込み中..."
            case "Loading hand poses...": return "ハンドポーズを読み込み中..."
            case "Couldn't load all poses and props. Please reload to try again.": return "一部のポーズと小道具を読み込めませんでした。ページを再読み込みしてもう一度お試しください。"

            // Untranslated strings
            case 'Export pose': return 'ポーズをエクスポート'
            case 'Export scene': return 'シーンをエクスポート'
            case 'Adjust limb sizes (exp.)': return '手足のサイズを調整（試験的）'
            case 'Camera position saved': return 'カメラ位置を保存しました'
            case '3D rendering interrupted. Restoring...': return '3Dレンダリングが中断されました。復元中...'
            case 'Unable to reach the license service. Please try again shortly.': return 'ライセンスサービスに接続できません。しばらくしてからもう一度お試しください。'
            case 'Upgrade to gain access to 200+ preset poses and save your own custom poses': return 'アップグレードすると200以上のプリセットポーズを利用でき、自分のポーズも保存できます'
            case 'Upgrade to gain access to the hand pose library': return 'アップグレードするとハンドポーズライブラリーを利用できます'
            case 'Upgrade to save your work in the cloud': return 'アップグレードすると作品をクラウドに保存できます'
            case 'Oh no!': return 'おっと！'
            case 'Something has gone terribly wrong (or the internet connection is unstable).': return '問題が発生しました（またはインターネット接続が不安定です）。'
            case 'Please try restarting the app.': return 'アプリを再起動してみてください。'
            case 'Restart': return '再起動'
            case "If that doesn't work, ensure that your browser or app is up-to-date.": return 'それでも解決しない場合は、ブラウザまたはアプリが最新であることを確認してください。'
            case 'If you keep seeing this error please': return 'このエラーが繰り返し表示される場合は'
            case 'email us': return 'メールでお問い合わせください'
            case 'Yes': return 'はい'
            case 'No': return 'いいえ'
            case 'Empty...': return '空です...'
            case 'Enter your license key': return 'ライセンスキーを入力してください'
            case 'Copy to clipboard failed': return 'クリップボードへのコピーに失敗しました'
            case 'Update payment information': return '支払い情報を更新'
            case 'Cancel subscription': return 'サブスクリプションをキャンセル'
            case 'Warning!\n\nBy cancelling you will lose your saved data.\n\nIf you would like to pause your subscription or get a discounted rate, email us at hello@justsketch.me and we\'ll try help you out.\n\nType "yes" to confirm your cancellation.': return '警告！\n\nキャンセルすると保存したデータは失われます。\n\nサブスクリプションの一時停止や割引をご希望の場合は、hello@justsketch.me までメールでご連絡ください。できる限り対応いたします。\n\nキャンセルを確定するには "yes" と入力してください。'
            case 'Delete {name}?': return '{name}を削除しますか？'
            case 'Set {file} to {character}?': return '{file}を{character}に適用しますか？'
            case '{discount}% off in {country}': return '{country}からは{discount}%オフ'
            case 'Use code {code} at checkout.': return 'お支払い時にコード {code} をご利用ください。'
            case 'Use code {code} at checkout on the website.': return 'ウェブサイトでのお支払い時にコード {code} をご利用ください。'


            // Keyboard shortcuts list
            case 'Keyboard shortcuts': return 'キーボードショートカット'
            case 'Rotate tool': return '回転ツール'
            case 'Move tool': return '移動ツール'
            case 'Scale tool': return '拡大縮小ツール'
            case 'Deselect, close menus, exit hand editor': return '選択解除、メニューを閉じる、ハンドエディタを終了'
            case 'Orbit camera around selection': return '選択範囲を中心にカメラを回転'
            case 'Hide or show selected': return '選択したものを表示/非表示'
            case 'Lock or unlock selected': return '選択したものをロック/ロック解除'
            case 'Place selected on ground': return '選択したものを地面に置く'
            case 'Flip selected': return '選択したものを反転'
            case 'Delete selected': return '選択したものを削除'
            case 'Toggle mirror posing': return 'ミラーポーズの切り替え'
            case 'Toggle lock camera': return 'カメラのロックを切り替え'
            case 'Undo': return '元に戻す'
            case 'Redo': return 'やり直す'
            case 'Hide tools': return 'ツールを隠す'
            case 'Show this list': return 'このリストを表示'

            default: lookup
        }
    }

    return lookup
}
